export function getVideoLength(seconds: number) {
  const safeSeconds = isFinite(seconds) && seconds >= 0 ? seconds : 0;
  if (safeSeconds < 3600) {
    return new Date(safeSeconds * 1000).toISOString().substring(14, 19);
  }
  return new Date(safeSeconds * 1000).toISOString().slice(11, 19);
}

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isBeforeWeekAgo(date: string) {
  const parsed = new Date(date).getTime();
  if (isNaN(parsed)) return true;

  return parsed < Date.now() - ONE_WEEK_MS;
}
